<template>
  <label
    class="input-checkbox"
  >
    <input
      v-model="previewDemoModel"
      @change="togglePreviewDemo($event)"
      type="checkbox"
      class="input-checkbox__input"
      :true-value="1"
      :false-value="0"
    />
    <span>{{$t('control.panel.preview_demo')}}</span>
  </label>
</template>

<script>
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useStateController from "@/views/Control/ControlPanel/ControlUnit/useStateController";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";

export default {
  setup() {
    const unitName = 'preview-demo';
    const store = useStore();

    const previewDemoModel = computed( {
      get() {
        return store.getters['control/previewDemo'];
      },
      async set(val) {
        await changeHandler({
          type: unitName,
          value: val,
        })
      }
    });

    function togglePreviewDemo(event) {
      if(event?.returnValue) {
        changeHandler({
          type: unitName,
          value: store.state.control.preview_demo,
        })
      }
    }

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      changeControlHandler({
        type: unitName,
        value: Number(getRouterQueryValue(unitName)),
      });
    });

    return {
      previewDemoModel,
      togglePreviewDemo,
      changeHandler
    };
  },
};
</script>

<style lang="scss" scoped>
.input-checkbox {
  margin-top: 10px;
}
</style>
